module.exports = __webpack_public_path__ + "img/PL00124.656634f0.png";